/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Export_FailedInputs */

const en_summary_export_failed = /** @type {(inputs: Summary_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not export the summary. Please try again.`)
};

const es_summary_export_failed = /** @type {(inputs: Summary_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo exportar el resumen. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Could not export the summary. Please try again." |
*
* @param {Summary_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const summary_export_failed = /** @type {((inputs?: Summary_Export_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Export_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_summary_export_failed(inputs)
	return en_summary_export_failed(inputs)
});